import React from 'react';
import styles from './styles.module.scss';
import Checkbox from '@profile/src/Components/Checkbox';
import classNames from 'classnames';

const CheckboxWithLabel = ({
  check,
  disabled,
  label,
  onChange,
  className
}) => {
  return /*#__PURE__*/React.createElement("div", {
    onClick: () => !disabled && (onChange === null || onChange === void 0 ? void 0 : onChange(!check)),
    className: classNames(styles.row, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.item
  }, /*#__PURE__*/React.createElement("span", null, label)), /*#__PURE__*/React.createElement(Checkbox, {
    disabled: disabled,
    check: check
  }));
};

export default CheckboxWithLabel;